React = require 'react'
Auth = require 'app/scripts/db/auth'
l = require 'app/scripts/lib/localize'
Promise = require 'bluebird'
updateTimezone = require 'app/scripts/lib/update-timezone'
$ = require 'jquery'
{ Apdex } = require '@trello/atlassian-analytics'
log = require 'app/scripts/debug/log'
_ = require 'underscore'
assert = require 'app/scripts/lib/assert'
ApiError = require 'app/scripts/network/api-error'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
{ trackGTMEvent, trackUe } = require '@trello/analytics'
{ memberRoutesViewLoaders } = require './member-routes-view-loaders'
Util = require 'app/scripts/lib/util'
{ Storage } = require '@trello/storage'
TrelloPerf = require('app/common/debug/perf').default
PerfKeys = TrelloPerf.Keys
{ featureFlagClient } = require '@trello/feature-flag-client'
{ renderTopLevelComponent } = require 'app/scripts/controller/renderTopLevelComponent'
{ unlessRouteChanged } = require 'app/scripts/controller/unlessRouteChanged'
{ Campaigns, MoonshotSteps } = require 'app/common/data/campaigns'

# Variables used to determine if we should pretend the user is new, for testing
# purposes
simulateNewUser = null

# keeps track if the browser forward or back buttons are used
browserNav = false
$(window).on 'popstate', ->
  browserNav = true

# keeps track of whether we redirected on initial page load
isInitial = false

module.exports =
  routes: [
    ['', 'memberHomeView']
    [':orgname/home', 'memberHomeBoardsView']
    [':orgname/highlights', 'memberHomeView']
    [':orgname/reports', 'teamReportsGateCheck']
    [':username/boards', 'memberAllBoardsView']
    [':username/cards', 'memberCardsView']
    [':username/cards/:orgname', 'memberCardsView']
    [':username/notifications', 'memberNotificationsView']
    [':username/activity', 'memberActivityView']
  ]

  teamReportsGateCheck: (orgname) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    Promise.using @getSpinner(), =>
      ModelLoader.release 'top-level'
      ModelLoader.for 'top-level', 'loadOrganizationMinimal', orgname
      .then (organization) =>
        if @isMemberOfOrg(orgname) && organization.belongsToRealEnterprise() && featureFlagClient.get('enterprise.reports', false)
          @teamReportView(organization)
        else
          @navigate(@getMemberOrgUrl(orgname, true), { trigger: true, replace: true })
      .catch ApiError, =>
        @displayErrorPage()
        return

  teamReportView: (organization) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    { TeamReportPage } = require 'app/src/components/TeamReportPage'

    renderTopLevelComponent(
      React.createElement(TeamReportPage, {
        teamName: organization.get('name'),
        modelCache: ModelCache
      })
    )

  displayMemberPage: (settings) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    MemberHomeView = require 'app/scripts/views/member/member-home-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    { username, loadFn, viewClass, getLocation, bodyClass, product, orgname, titleKey, superHomeAllBoardsTab, openNotifications } = settings
    username ?= Auth.myUsername()

    log('controller', ['memberHomeView'])

    Promise.using @getSpinner(), =>
      ModelLoader.release 'top-level'
      ModelLoader.for 'top-level', loadFn, username
      .then (member) =>
        if member.campaignIsActive(Campaigns.MOONSHOT) &&
         featureFlagClient.get('btg.moonshot')
          campaign = member.getCampaign(Campaigns.MOONSHOT)
          if campaign.currentStep != MoonshotSteps.WELCOME
            return @navigate '/create-first-team', { trigger: true }

        memberHasNoBoards = member.boardList.length == 0

        simulateNewUser ?= $.cookie('simulateNewUser')

        isNewUser = simulateNewUser ||
          Util.idToDate(Auth.myId()) > Util.dateBefore({ days: 7 })

        if viewClass == MemberHomeView && isNewUser && memberHasNoBoards && !Auth.me().isDismissed('create-first-board')
          return @redirectToWelcome(member)

        @clearPreviousView()
        @setViewType(member)

        title =
          if Auth.isMe(member) && titleKey?
            l(['page title', titleKey])
          else
            member.getMemberViewTitle()

        # Do this before creating the view, in case the view has more
        # specific logic for setting the URL
        @setLocation
          title: title
          location: getLocation.call(@, member.get('username'), product)
          options:
            replace: true

        options = { product, orgname, modelCache: ModelCache, superHomeAllBoardsTab, openNotifications }

        memberView = @topLevelView(viewClass, member, options)
        @showHeader(@headerOptsForHome(options))
        @maybeShowFooterChrome(@getMemberBoardsUrl(member.get('username'), orgname, superHomeAllBoardsTab))

        if bodyClass
          $('#trello-root').addClass(bodyClass)
        else
          $('#trello-root').addClass('body-tabbed-page')

        $('#content').html(memberView.render().el)
        @focusContent()
        memberView.getData?()

        return
      .catch ApiError, =>
        @displayErrorPage()
        return

  headerOptsForHome: ({ orgname, modelCache }) ->
    return {} unless orgname && modelCache
    organization = modelCache.findOne('Organization', 'name', orgname)
    if organization?.get('idEnterprise')? && organization?.getEnterprise()?
      enterprise = organization.getEnterprise()
      {
        headerBrandingColor: enterprise.get('prefs')?.brandingColor
        headerBrandingLogo: enterprise.getHeaderLogo()
      }
    else
      {}

  redirectToWelcome: (member) ->
    # There are two types of first boards to use: the default one we
    # auto-create for users, and madlibs. First step is to determine which
    # method to use.
    memberDoesNotBelongToTeams = member.organizationList.length == 0
    if memberDoesNotBelongToTeams
      if featureFlagClient.get('activation.onboarding_v2')
        return @navigate '/welcome', { trigger: true }
      else
        return @navigate '/create-first-board', { trigger: true }

    # Data that we'll use in the body of the POST to create the default board
    initialData =
      name: l(['untitled board'])

    # Data that we're going to send in the create request; not all of the
    # fields will be board attributes
    requestData = _.extend({
      prefs_permissionLevel: 'private'
      prefs_selfJoin: true
      defaultLists: true
      creationMethod: 'automatic'
    }, initialData)

    newBoard = member.boardList.create initialData, {
      requestData: requestData
      success: (board) =>
        # this fixes an issue with idBoards not being updated at the time that
        # the board gets rendered and the client thinking the member is not on
        # the board
        if board.id !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(board.id))

        # We have to wait until we get the board id back before we can
        # display the board
        @displayBoard({
          idBoard: board.id
          openListComposer: false
        }).done()

        return
      error: =>
        @displayErrorPage()
    }

    return

  memberAllBoardsView: (username) ->
    # caught by ':username/boards' route
    # but we actually want to show the 'memberHomeView'
    # just without any organisation, to show the SH all boards tab
    @memberHomeView(null, true)

  memberHomeBoardsView: (orgname) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    # Error early for not-logged-in users
    if !Auth.isLoggedIn()
      # a not-logged-in user cannot be a member of any board
      return @displayErrorPage()

    # Redirect early for non-existent orgs, before trying to load models
    ModelCache.waitFor 'Member', Auth.myId(), =>
      if !@isMemberOfOrg(orgname)
        return @redirectHomeToDefaultTab()

      # this is will show the org boards
      # adding these model loaders so we can show org boards that the user isn't a member of
      ModelLoader.release 'top-level'
      unlessRouteChanged(
        ModelLoader.for 'top-level', 'loadOrganizationBoardsData', orgname
      ).then (org) =>
        @memberHomeView(orgname, true)
      .catch -> null

  memberHomeView: (orgname, superHomeAllBoardsTab, openNotifications) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    MemberHomeView = require 'app/scripts/views/member/member-home-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'

    if !Auth.isLoggedIn()
      # Hopefully you're not being routed here if you aren't logged in and
      # the server is sending you to the home page
      return @displayErrorPage()

    apdexTask = if superHomeAllBoardsTab then 'memberBoards' else 'memberHome'
    perfKey = if superHomeAllBoardsTab then PerfKeys.BOOTSTRAP_SUPERHOME_VIEW else PerfKeys.BOOTSTRAP_HOME_VIEW
    Apdex.start(task: apdexTask)
    TrelloPerf.startMeasurement(perfKey)

    ModelCache.waitFor 'Member', Auth.myId(), =>
      lastHomeTab = @getHomeLastTab()
      # if there is no orgname or it's not on all boards tab then it means we are on '/'
      # in that case if there is a last home tab that isn't '/' we want to redirect to that
      if !orgname && !superHomeAllBoardsTab && lastHomeTab && lastHomeTab != '/' && !browserNav
        browserNav = false

        # When a user lands on `/` and immediately gets redirected to `/:username/boards`,
        # we want to treat that as an "initialLoad" rather than a "transition" for Apdex
        # purposes. We need to explicitly tell the Apdex client this information, since
        # the URL change makes it look like we're doing a client-side transition even
        # though this the first rendered page the user is seeing.
        Apdex.cancel(task: apdexTask)
        isInitial = Apdex.isInitialLoad && Apdex.initialUrl == window.location.href

        return @navigate lastHomeTab, { trigger: true, replace: true, shouldTrack: false }
      else if browserNav
        # if navigating with browser nav buttons then we need to set the last tab
        Storage.set(@getHomeLastTabStorageKey(), window.location.pathname)

      if orgname && !@isMemberOfOrg(orgname)
        return @redirectHomeToDefaultTab()

      @trackMemberHomeView(orgname, superHomeAllBoardsTab)

      browserNav = false
      # If you're logged in, always kick you to your own boards page, since you
      # can't see anyone elses
      simulateNewUser ?= $.cookie('simulateNewUser')
      opts =
        username: 'me'
        loadFn: 'loadMemberBoardsData'
        viewClass: MemberHomeView
        getLocation: (username) =>
          @getMemberBoardsUrl(username, orgname, superHomeAllBoardsTab)
        titleKey: 'boards'
        orgname: orgname
        superHomeAllBoardsTab: superHomeAllBoardsTab
        openNotifications: openNotifications

      @displayMemberPage(opts)
        .then(updateTimezone)
        .then(=>
          title = if typeof orgname == 'undefined'
            l(['page title', 'home'])
          else if !orgname && superHomeAllBoardsTab
            l(['page title', 'boards'])
          else
            ModelCache.findOne('Organization', 'name', orgname)?.get('displayName')
          @title(title)
        )
        .tap ->
          if apdexTask != 'memberBoards' then return

          if isInitial then Apdex.resetInitialState()
          Apdex.stop(task: apdexTask)

          TrelloPerf.stopMeasurement(perfKey)
          TrelloPerf.reportStartupMetrics()

          isInitial = false
        .done()

      if( simulateNewUser || Util.idToDate(Auth.myId()) > Util.dateBefore({ minutes: 3 }))
        trackGTMEvent({
          event: 'trello.possibleNewSignup'
        })

  getHomeDefaultTab: ->
    @getMemberBoardsUrl(Auth.myUsername(), null, true, null)

  getHomeLastTabStorageKey: ->
    "home_#{Auth.myId()}_last_tab_2"

  getHomeLastTab: ->
    Storage.unset("home_#{Auth.myId()}_last_tab") # Clean up old key

    defaultTab = @getHomeDefaultTab()
    lastHomeTab = Storage.get(@getHomeLastTabStorageKey())

    if !lastHomeTab?
      return defaultTab

    if !(lastHomeTab == '/' || lastHomeTab.endsWith('/boards') || lastHomeTab.endsWith('/home'))
      # Clear out any invalid values
      Storage.unset(@getHomeLastTabStorageKey())
      return defaultTab

    return lastHomeTab

  redirectHomeToDefaultTab: ->
    Storage.unset(@getHomeLastTabStorageKey())
    @navigate(@getHomeDefaultTab(), { trigger: true, replace: true })

  isMemberOfOrg: (orgname) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'

    orgs = ModelCache.get('Member', Auth.myId())?.getSortedOrgs()
    return orgs.find((org) => org.get('name') == orgname)

  trackMemberHomeView: (orgname, superHomeAllBoardsTab) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'

    dirObj = ''
    context = {}

    if orgname && superHomeAllBoardsTab
      dirObj = 'team tab'
      context = {
        teamId: ModelCache.findOne('Organization', 'name', orgname)?.id
      }
    else if !orgname && superHomeAllBoardsTab
      dirObj = 'boards tab'
    else if !orgname && !superHomeAllBoardsTab
      dirObj = 'home tab'
    else
      return

    trackUe('home', 'loads', dirObj, '', '', '', context)

  memberNotificationsView: (username = 'me') ->
    # The member notifications view has been removed so
    # instead we redirect them to the homepage
    # with the notifications pane open
    return @memberHomeView(null, false, false, true)

  memberProfileView: (username = 'me') ->
    memberRoutesViewLoaders.memberProfile()
    .then (MemberProfileView) =>
      @displayMemberPage
        username: username,
        loadFn: 'loadMemberProfileData'
        viewClass: MemberProfileView
        getLocation: @getMemberProfileUrl
        titleKey: 'profile'
      .done()

  memberActivityView: (username = 'me') ->
    memberRoutesViewLoaders.memberActivity()
    .then (MemberActivityView) =>
      @displayMemberPage
        username: username,
        loadFn: 'loadMemberProfileData'
        viewClass: MemberActivityView
        getLocation: @getMemberActivityUrl
        titleKey: 'activity'
      .done()

  memberCardsView: (username = 'me', orgname) ->
    memberRoutesViewLoaders.memberCards()
    .then (MemberCardsView) =>
      @displayMemberPage
        username: username
        loadFn: 'loadMemberCardsData'
        viewClass: MemberCardsView
        getLocation: (username) =>
          @getMemberCardsUrl(username, orgname)
        titleKey: 'cards'
        orgname: orgname
      .done()

  memberAccountView: (username) ->
    username = 'me'
    memberRoutesViewLoaders.memberAccount()
    .then (MemberAccountView) =>
      @displayMemberPage
        username: username
        loadFn: 'loadMemberAccountData'
        viewClass: MemberAccountView
        getLocation: @getMemberAccountUrl
        titleKey: 'settings'
      .done()

  memberBillingView: (username) ->
    username = 'me'
    memberRoutesViewLoaders.memberBilling()
    .then (MemberBillingView) =>
      @displayMemberPage
        username: username
        loadFn: 'loadMemberBillingData'
        viewClass: MemberBillingView
        getLocation: @getMemberBillingUrl
        titleKey: 'billing'
      .done()
